import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import * as ProviderSessionActions from "../../state/redux/providerSession";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import AdminPatients from "../widgets/adminPatients";
import ProviderPatients from "../widgets/providerPatients";

const ProviderPortal = props => {
  const { providerODM, userODM, loadProviderODMRequest } = props;

  useEffect(() => {
    if (providerODM == null && userODM != null) {
      loadProviderODMRequest(userODM._id);
    }
  }, [providerODM, userODM, loadProviderODMRequest]);

  return (
    <Portal>
      <PortalAppBar title="Health Provider" />
      {providerODM && (
        <PortalGridContent>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <ProviderPatients />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={8}>
            <AdminPatients />
          </Grid>
          <Grid item xs={12}></Grid>
        </PortalGridContent>
      )}
    </Portal>
  );
};

const mapStateToProps = state => ({
  providerODM: state.providerSession.providerODM,
  awsGroup: state.userSession.awsGroup,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  loadProviderODMRequest: ProviderSessionActions.loadProviderODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProviderPortal));
